module.exports = __webpack_public_path__ + "static/img/point_1.2e9eb74c.png";